import React, {useEffect, useState} from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import FormElement from './FormElement';
import moment from 'moment';
import DateBind from './DateBind';
import periodValues from '../constants/period.values'
import Loading from 'components/Loading';
import {connect} from 'react-redux'
import getObjectValue from 'libs/getObjectValue'
import * as Yup from 'yup';
import ScheduleService from 'services/ScheduleService';
import {withRouter} from "react-router";
import SaveFormikValues from 'components/SaveFormikValues';
import {DemandValidation} from 'constants/DemandValidation';
import VS from "constants/ValidationShema";
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import {setFormDraftLoaded} from "redux/actions";
import Confirm from "components/popup/confirm/Confirm";
import AutoSaveFormValues from "components/AutoSaveFormValues";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import saveFormDraft from "libs/saveFormDraft";

function Deadlines(
    {
        scheduleList,
        stepperState,
        demandValidation,
        match,
        setFormDraftLoaded,
        demandHeader
    }) {
    const id = match.params.id;
    const section = demandValidation.find(x => x.section === DemandValidation.SCHEDULE);
    const FORM_ID = 'mp_1_schedule';
    const [draftConfirm, setDraftConfirm] = useState(false);
    const [working, setWorking] = useState(false);
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    useStepperStateCloseValidator(FORM_ID, undefined,
        autoSaveFormDraftActive ? () => ScheduleService.deleteDraft(id) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(id, ScheduleService.saveDraft, FORM_ID) : undefined);

    useEffect(() => {
        ScheduleService.getList(id).then(() => {
            if (autoSaveFormDraftActive)
                ScheduleService.checkForDraft(id).then(res => setDraftConfirm(res.result))
        });

        return () => ScheduleService.clearSchedule()
    }, [id, autoSaveFormDraftActive])

    const handleSubmit = (values, formikProps) => {
        ScheduleService.save(id, values)
            .then((result) => {
                if (result && !result.success) {
                    const errors = result.errors;
                    let errorObj = {}
                    Object.keys(errors).forEach((errorId) => {
                        const erId = errorId.split('.')[1];
                        errorObj[erId] = errors[errorId];
                    })
                    formikProps.setErrors(errorObj)
                }
            })
    }

    const getField = (id, defaultValue = '') => getObjectValue(id, scheduleList.schedules.length > 0 ? scheduleList.schedules[0] : {}, defaultValue)

    const validationSchema = Yup.lazy((value) => {
        const schema = {
            offerEndDate: VS.dateTimeMin(new Date(), Tr('v_time_can_not_be_past')),
            offerOpenDate: VS.dateTimeValid()
                .when('offerEndDate', (offerEndDate, schema) => {
                    return schema.test('EndDateLessOpenDate', Tr("EndDateLessOpenDate"), (offerOpenDate) => {
                        if (offerEndDate && offerOpenDate) {
                            return !offerOpenDate.isBefore(offerEndDate);
                        }
                        return false;
                    })
                })
        }

        let offerOpenDateClone = moment.isMoment(value.offerOpenDate) ? (value.offerOpenDate.isValid() ? value.offerOpenDate.clone().startOf("day") : moment()) : moment();
        offerOpenDateClone = offerOpenDateClone.isBefore(moment().add(1, 'day')) ? moment().add(1, 'day') : offerOpenDateClone;

        if (value.bindWithOfferPeriodOrDate.pickDateInsteadOfPeriod === 'true') {
            schema['bindWithOfferPeriodOrDate'] = Yup.object().shape({
                date: VS.dateMin(offerOpenDateClone, Tr('periodDateLessThanOpenDate'))
            })

        }

        return Yup.object().shape(schema);
    })

    const getPickDateInsteadOfPeriod = () => {
        const date = getField('bindWithOfferPeriodOrDate.date', null);
        if (date === null) {
            const periodLen = getField('bindWithOfferPeriodOrDate.period.length', null);
            if (periodLen === null) return 'empty'
            return 'false'
        }
        return 'true'
    }
    const handleEndDate = (formikProps, value) => {
        formikProps.setFieldValue('offerOpenDate', value);
        formikProps.setFieldTouched('offerOpenDate', true);
        formikProps.validateField('offerOpenDate');
    }
    const getInitValues = () => ({
        _editable: section ? section.editable : true,
        stageNumber: getField('stageNumber'),
        stageName: getField('stageName'),
        questionEndDate: getField('questionEndDate', null),

        identity: getField('identity'),
        offerEndDate: moment(getField('offerEndDate', new Date())),
        offerOpenDate: moment(getField('offerOpenDate', new Date())),
        bindWithOfferPeriodOrDate: {
            date: moment(getField('bindWithOfferPeriodOrDate.date', new Date())),
            period: {
                length: getField('bindWithOfferPeriodOrDate.period.length', periodValues[0].value),
                name: getField('bindWithOfferPeriodOrDate.period.name', 'day'),
            },
            pickDateInsteadOfPeriod: getPickDateInsteadOfPeriod(),
        }
    })

    const loadScheduleDraft = () => {
        setDraftConfirm(false);
        setWorking(true);
        ScheduleService.loadDraft(id).then(res => setFormDraftLoaded(FORM_ID, res.success));
        setWorking(false);
    }

    if (!scheduleList || working) {
        return <Loading/>
    }

    return (
        <div>
            <Form
                initialValues={getInitValues()}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                id={FORM_ID}
                afterSubmitFunc={() => {
                    if (isDemandModification()) {
                        ModificationService.isDemandChanged(id);
                    }
                }}
            >
                {(formikProps) => (
                    <>
                        <SaveFormikValues
                            formikProps={formikProps}
                            id={FORM_ID}
                            save={FORM_ID === stepperState}
                        />
                        {autoSaveFormDraftActive &&
                        <AutoSaveFormValues
                            formikProps={formikProps}
                            id={id}
                            formId={FORM_ID}
                            saveFunc={(formValues) => {
                                ScheduleService.saveDraft(id, formValues)
                            }}
                        />
                        }
                        <GridBlock
                            direction='column'
                        >
                            <Typography variant='h6'>
                                {Tr('offers')}
                            </Typography>
                            <FormElement
                                title={Tr('deadline_for_offers')}
                                formikProps={formikProps}
                                id={'offerEndDate'}
                                onChange={(value) => handleEndDate(formikProps, value)}
                                required
                            />
                            <FormElement
                                title={Tr('date_opening_offers')}
                                formikProps={formikProps}
                                id={'offerOpenDate'}
                                required
                            />
                            <DateBind
                                title={Tr('date_binding_offer')}
                                formikProps={formikProps}
                                initialPickDateInsteadOfPeriod={getPickDateInsteadOfPeriod()}
                            />
                        </GridBlock>
                    </>
                )}
            </Form>
            <Confirm
                open={draftConfirm}
                onConfirm={loadScheduleDraft}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </div>
    )
}

Deadlines.propTypes = {
    classes: PropTypes.any,
}

Deadlines.defaultProps = {}

export default connect((state) => ({
    scheduleList: state.resources.schedule,
    stepperState: state.stepper.state,
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader
}), {setFormDraftLoaded})(withRouter(Deadlines));

